import styled from 'styled-components';
import { beam } from '@styles/colors/themes';

export const SearchContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  flex: 1;
  width: 430px;
  margin-bottom: 16px;
`;
export const RowContainer = styled.div`
  display: flex;
  margin-left: 24px;
  flex-direction: row;
  justify-content: center;
  width: 400px;
  margin-bottom: 16px;
`;
export const SubHeader = styled.h3`
  margin-bottom: 16px;
  width: 100%;
  /* Layout Properties */
  text-align: left;
  font-weight: 500;
  letter-spacing: 0;
  font-style: normal;
  font-size: 16px;
  line-height: 24px;

  color: ${beam.font.primary};
  opacity: 1;
`;

export const Filter = styled.div`
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.161);
  background: #fff;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  cursor: pointer;
  margin-left: 16px;
`;
export const ButtonText = styled.h3`
  margin-right: 8px;
  color: ${beam.font.primary};
  opacity: 1;
  font-size: 14px;
  text-align: center;
  align-items: center;
  justify-content: center;
  display: flex;
`;

export const LinkText = styled.h3`
  color: ${beam.font.link};
  opacity: 1;
`;
export const ModelText = styled.h3`
  margin-right: 8px;
  color: ${beam.font.primary};
  font-weight: 500;
  opacity: 1;
`;
